function Buttons() {
	this.build();
}

Buttons.prototype.build = function () {
	const arrow = document.querySelector('#arrowtojs').innerHTML;

	$('.btn--go').each(function(index, elem) {
		$(elem).append(arrow);
	});

	$('.btn--back').each(function(index, elem) {
		$(elem).prepend(arrow);
	});
};
